import {
  useLayoutEffect,
  type Dispatch,
  type RefObject,
  type SetStateAction,
} from 'react';
import { getViewportSafePopoutPosition } from '../utils/popoutPosition';

type CalendarPopoutPosition = { x: number; y: number };

interface UseCalendarVisitPopoutOptions {
  popoutVisible: boolean;
  popoutRef: RefObject<HTMLDivElement>;
  popoutPosition: CalendarPopoutPosition;
  setPopoutPosition: Dispatch<SetStateAction<CalendarPopoutPosition>>;
  popoutDate: Date | undefined;
  visitsByDate: unknown;
}

export function useCalendarVisitPopout({
  popoutVisible,
  popoutRef,
  popoutPosition,
  setPopoutPosition,
  popoutDate,
  visitsByDate,
}: UseCalendarVisitPopoutOptions) {
  useLayoutEffect(() => {
    if (!popoutVisible || !popoutRef.current) return;

    const rect = popoutRef.current.getBoundingClientRect();
    const nextPosition = getViewportSafePopoutPosition(
      popoutPosition,
      { width: rect.width, height: rect.height },
      { width: window.innerWidth, height: window.innerHeight }
    );

    if (
      nextPosition.x !== popoutPosition.x ||
      nextPosition.y !== popoutPosition.y
    ) {
      setPopoutPosition(nextPosition);
    }
  }, [
    popoutVisible,
    popoutRef,
    popoutDate,
    visitsByDate,
    popoutPosition,
    setPopoutPosition,
  ]);
}
